import {
  flattenArrayUtil,
  toSnakeCaseStringUtil
} from 'packages/src'

// TODO move to packages
export default function getActionStrReduxUtil (action, ...keys) {
  keys = flattenArrayUtil(keys)

  if (!keys || !keys.length) {
    return action
  }

  const prefix = action.toUpperCase()
  const formattedKeysStr = keys.map(key => {
    key = key + ''

    if (key.includes('_')) {
      return key.toUpperCase()
    }

    return toSnakeCaseStringUtil(key).toUpperCase()
  })

  const suffix = formattedKeysStr.join('_')
  return `${prefix}_${suffix}`
}
